import { IMAGE_GENERATION_THEMES, type ImageGenerationTheme } from '../types';

export type RemixImageGenerationStyle =
	| Exclude<ImageGenerationTheme, typeof IMAGE_GENERATION_THEMES.threeD>
	| '3d';

export const toRemixImageGenerationStyle = (
	theme: ImageGenerationTheme,
): RemixImageGenerationStyle => (theme === IMAGE_GENERATION_THEMES.threeD ? '3d' : theme);
